import React from 'react';
import { Formik } from 'formik';
import FormGrid from '../../../components/Form/FormGrid';
import TextField from '@material-ui/core/TextField';
import { PrimaryButton } from '../../../components/Buttons';
import styled from 'styled-components';
import NumberFormat from 'react-number-format';
import appConfig from '../../../../app-config';

const Button = styled(PrimaryButton)`
  height: 56px;
  width: 392px;
  border-radius: ${(props) => props.theme.giftCardButtonRadius};
`;

const FormLayout = styled(FormGrid)`
  grid-gap: 20px;
`;

const ConnectExistingGiftCard = ({ handleConnectExistingGiftCard }) => {
  const { specificGiftCardFlow } = appConfig;
  return (
    <Formik
      initialValues={{ giftCardNumber: '', pin: '' }}
      validate={(values) => {
        let errors = {};
        if (!values.giftCardNumber) {
          errors.giftCardNumber = 'Required';
        }
        if (!values.pin && specificGiftCardFlow) {
          errors.pin = 'Required';
        }
        return errors;
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleReset,
        dirty,
        isValid,
        setFieldValue,
      }) => (
        <form>
          <FormLayout>
            <NumberFormat
              id='ExistingGiftCard-CardNumber'
              label='Card Number (Required)'
              name='giftCardNumber'
              value={values.giftCardNumber}
              onChange={(e) => setFieldValue('giftCardNumber', e.target.value)}
              customInput={TextField}
              onBlur={handleBlur}
              error={
                touched.giftCardNumber && errors.giftCardNumber ? true : false
              }
              helperText={
                touched.giftCardNumber && errors.giftCardNumber
                  ? 'Please enter gift card number'
                  : ''
              }
              format='#### #### #### #### #### ###'
            />
            <NumberFormat
              id='ExistingGiftCard-Pin'
              label={`Pin (${specificGiftCardFlow ? 'Required' : 'Optional'})`}
              name='pin'
              value={values.pin}
              onChange={(e) => setFieldValue('pin', e.target.value)}
              customInput={TextField}
              onBlur={handleBlur}
              error={touched.pin && errors.pin ? true : false}
              helperText={touched.pin && errors.pin}
            />
            <Button
              id='ExistingGiftCard-AddGiftCard'
              type='submit'
              disabled={!dirty || !isValid}
              onClick={() => {
                handleReset();
                handleConnectExistingGiftCard(values);
              }}
            >
              Connect an Existing Gift Card
            </Button>
          </FormLayout>
        </form>
      )}
    </Formik>
  );
};

export default ConnectExistingGiftCard;
